module.exports = "<p>\n  transfer-recorders-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/transfer/transfer-recorders/transfer-recorders-form/transfer-recorders-form.component.html
// module id = ./src/app/hrms/transfer/transfer-recorders/transfer-recorders-form/transfer-recorders-form.component.html
// module chunks = main